import React, { useEffect, useContext } from "react";
import {
  GridContainer,
  GridItem,
  MonthlyReportFormRootArea,
} from "./MonthlyReport.styles";
import {
  monthlyReportInitialValues,
  monthlyReportValidationSchema,
  getLastThreeCompletedMonths,
} from "./MonthlyReport.resources";
import { useFormik } from "formik";
import SelectField from "../../selectField/SelectField";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { generateMonthlyReport } from "./MonthlyReport.thunk";
import AuthContext from "../../../context/AuthContext";
import { useModal } from "../../modal";
import AdminFields from "../../adminFields/AdminFields";
import {
  setApplyChanges,
  setWasUsed,
  setReset,
} from "../../adminFields/AdminFields.slice";
import MonthlyReportResultModal from "./MonthlyReport.resultModal";
import moment from "moment";

const MonthlyReport = () => {
  const dispatch = useDispatch();
  const { token, acquirerData, userInfo } = useContext(AuthContext);
  const { open } = useModal();
  const { status } = useSelector((state) => state.monthlyReport);
  const {
    applyChanges,
    acquirerId: storeAcquirerId,
    wasUsed,
    reset,
  } = useSelector((state) => state.adminFields);

  const handleOpenResultModal = () => {
    const monthLabel = getLastThreeCompletedMonths().find(
      (month) => month.value === values.reportDate
    )?.label || moment(values.reportDate).format("MMMM YYYY");
    open({
      title: `Residuals Report - ${monthLabel}`,
      maxWidth: `lg`,
      fullWidth: true,
    });
  };

  const {
    values,
    handleSubmit,
    isSubmitting,
    handleChange,
    handleBlur,
    errors,
    touched,
    setSubmitting,
    validateForm,
  } = useFormik({
    initialValues: monthlyReportInitialValues,
    validationSchema: monthlyReportValidationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: false,
    onSubmit: (values) => {
      let userType = '';
      if (['acquirer', 'acquirer-iso'].includes(userInfo["acquirer-rol-data"])) {
        userType = 'acquirer';
      }
      if (userInfo["acquirer-rol-data"] === "ISO") {
        userType = 'iso';
      }
      if (['merchant', 'merchant-iso'].includes(userInfo["acquirer-rol-data"])) {
        userType = 'merchant';
      }
      if (userInfo["acquirer-rol-data"] === "admin") {
        userType = 'admin';
      }
      setSubmitting(true);
      dispatch(
        generateMonthlyReport({
          reportDate: values.reportDate,
          token: token,
          acquirerData,
          onSuccessCallback: handleOpenResultModal,
          userType,
        })
      );
      setSubmitting(false);
    },
  });

  useEffect(() => {
    if (reset) {
      dispatch(setReset(false));
    }
  }, [reset, dispatch]);

  useEffect(() => {
    if (applyChanges) {
      dispatch(setApplyChanges(false));
      dispatch(setWasUsed(true));
    }
  }, [applyChanges, dispatch]);

  useEffect(() => {
    if (wasUsed && storeAcquirerId === "") {
      dispatch(setApplyChanges(false));
      dispatch(setWasUsed(false));
    }
  }, [storeAcquirerId, wasUsed, dispatch]);

  useEffect(() => {
    // Force validation when month value changes
    if (values.reportDate) {
      validateForm();
    }
  }, [values.reportDate, validateForm]);

  return (
    <MonthlyReportFormRootArea>
      <GridContainer component="form" onSubmit={handleSubmit} >
        <MonthlyReportResultModal />
        <GridContainer justifyContent="space-between" alignItems="center">
          <GridItem xs={12} md={6} lg={5} padding="15px 15px 15px 0">
            <SelectField
              id="reportDate"
              name="reportDate"
              fullWidth
              label="Month"
              value={values.reportDate}
              onChange={handleChange}
              onBlur={handleBlur}
              options={getLastThreeCompletedMonths()}
              required
              error={errors.reportDate}
              touched={touched.reportDate}
              helperText="Select one of the last 3 completed months"
            />
          </GridItem>
          <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
            <Button
              variant="contained"
              type="submit"
              size="large"
              disabled={isSubmitting || status === "loading"}
              loading={isSubmitting || status === "loading"}
              onClick={handleSubmit}
            >
              Generate Report
            </Button>
          </GridItem>
        </GridContainer>
      </GridContainer>
    </MonthlyReportFormRootArea>
  );
};

export default MonthlyReport;

